import { useEffect, useState } from 'react';
import { subscribeToTrackWorkers } from '../../services/TrackJobsService';

// Re-render this often so "on" decays to "off" when a Mac stops checking in:
// a Mac that went to sleep writes nothing, so no snapshot would ever say so.
const TICK_MS = 15 * 1000;

/**
 * The studio Macs' check-ins ("Add a track", build step 2), plus a clock, so
 * the control can say who will remove the vocals before the teacher adds a
 * track. Only subscribes while `enabled` (a song tab with a student): the
 * lesson page mounts on every lesson and most never add a track.
 */
const useTrackWorkers = (enabled) => {
	const [workers, setWorkers] = useState([]);
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		if (!enabled) return undefined;
		const unsubscribe = subscribeToTrackWorkers(setWorkers, () => setWorkers([]));
		const tick = setInterval(() => setNow(Date.now()), TICK_MS);
		return () => {
			unsubscribe();
			clearInterval(tick);
		};
	}, [enabled]);

	return { workers, now };
};

export default useTrackWorkers;
